<template>
    <div id="contendor-principal-fraccionamientos">
       <div id="contenedor-encabezados-fraccionamientos" class="text-left">
            <h1>FRACCIONAMIENTOS</h1>
        </div>
        <div id="encabezado-contenedor-contenido" class="form-inline mt-3">
            <div class="flex-grow-1 pl-3"><h4>Administración de fraccionamientos</h4></div>
        </div>
        <div id="contendor-fraccionamientos">
             <div class="area col-12">
               <!--  <div v-if="!SEPOMEX.seccion.visualizar" id="menuConsultaExterna" class="form-inline justify-content-end">
                    <h6 class="mr-3" @click="SEPOMEX.seccion.visualizar = true"><i class="fas fa-search"></i>&nbsp;Consulta externa</h6>
                </div> -->
                <div v-if="SEPOMEX.seccion.visualizar" class="contenedor-color-negro mt-2 container-fluid">
                   <div class="d-flex justify-content-between">
                        <h5><i class="fas fa-info-circle"></i>&nbsp;Consulta de fraccionamientos SEPOMEX</h5>
                        <button type="button" id="btn-datos-plantilla" @click="evtCerrarSeccionSEPOMEX" class="btn btn-danger"><i class="fas fa-window-close"></i>&nbsp;&nbsp;Cerrar</button>
                   </div>
                    <div class="row pb-0 pt-0 pl-3 mt-4">
                        <div class="form-inline mt-3 pr-3">
                            <h6>Municipio</h6>
                            <C010Municipios :class="[SEPOMEX.filtros.mostrarErrores && !this.campoRequeridoEsValido(SEPOMEX.filtros.tipoMunicipioId) ? 'p-0 m-0 ml-1 border border-danger' : 'p-0 m-0 ml-1']"
                                v-on:valorParaElPadre="cambioDeMunicipioSEPOMEX" 
                                :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                :idDelInput="'FiltroTipoMuncipioSEPOMEX'" 
                                :parametros="{EntidadFederativaId: enumeraciones.pj.entidadesFederativas.Aguascalientes}" 
                                :valorDefinido="SEPOMEX.filtros.tipoMunicipioId" 
                                :key="'CMunicipioFSEPOMEX' + SEPOMEX.filtros.contadorRenderCatalogos"></C010Municipios>
                        </div>
                        <div class="form-inline mt-3">
                            <button @click="busquedaFraccionamientosSEPOMEX" type="button" id="btn-datos-plantilla" class="btn btn-primary"><i class="fas fa-search"></i>&nbsp;&nbsp;Realizar búsqueda</button>
                        </div>
                    </div>
                    <hr style="height:2px;border:none;color:#FFF;background-color:#FFF;" class="mt-3"/>
                    <div>
                        <div id="filtros-memoria-fracc-vcdd" class="form-inline mb-3 justify-content-end">
                            <div id="filtros-input-fracc-memoria" class="f-item form-group mr-sm-2">
                                <h6 for="f-busqueda" class="mr-sm-2">Buscar:</h6>
                                <input v-model="SEPOMEX.filtros.buscarPor" type="text" id="f-busqueda" placeholder="Buscar en todas las columnas" class="form-control" style="width: 300px;"/>
                            </div>
                            <div class="f-item form-group">
                                <button type="button" id="btn-limpiar-filtro" @click="evtResetearFiltros" class="btn-sm btn-primary"><i class="fas fa-undo"></i></button>
                            </div>
                        </div>
                         <div id="titulo-tabla">
                            <h4>Fraccionamientos registrados en SEPOMEX</h4>
                        </div>
                        <CTablaGenericaCedulas class="table-responsive" v-show="!SEPOMEX.filtros.cargandoFraccionamientos"
                            :idDelInput="SEPOMEX.tablaRegistros.ID_TABLA"
                            :encabezadosColumnas="SEPOMEX.tablaRegistros.encabezados"
                            :accionesEnTabla="{motrarAcciones: true,check: true, eliminar: false, editar: false,imprimir: false, ver: false}"
                            :listaDeCedulas="SEPOMEX.fraccionamientosSEPOMEXFiltrados"
                            v-on:elementosSeleccionados="evtFraccSEPOMEXSeleccionados"
                            :key="SEPOMEX.tablaRegistros.ID_TABLA + SEPOMEX.tablaRegistros.render"></CTablaGenericaCedulas>
                        <div v-if="SEPOMEX.filtros.cargandoFraccionamientos" class="contenedor-cargando" style="height: 300px ;">
                            <div class="text-center">
                                <i class="fas fa-spinner fa-spin fa-5x"></i>
                                <h4 class="mt-4">Cargando fraccionamientos</h4>
                            </div>
                        </div>
                        <div v-if="SEPOMEX.fraccARegistrar.some(f => f.enviar)" id="contenedor-campos-informativos-guardar">
                            <h6>[#Fraccionamientos seleccionados: {{obtenerNumeroDeFraccionamientos + ']'}}</h6>
                            <button type="button" @click="evtGuardarFraccionamientosSEPOMEX" class="btn btn-primary justify-content-end"><i class="fas fa-save"></i>&nbsp;&nbsp;Guardar en catalogo</button>
                        </div>
                    </div>
                </div>
                <div class="contenedor-color-negro mt-4">
                    <h5><i class="fas fa-book"></i>&nbsp;&nbsp;Catálogo de fraccionamientos SINOJ</h5>
                    <div class="d-flex justify-content-end mb-2 mt-4">
                        <button @click="eventoFiltrarFraccionamientos" type="button" id="btn-datos-plantilla" class="btn btn-primary"><i class="fas fa-search"></i>&nbsp;&nbsp;Realizar búsqueda</button>
                        <button v-if="administraTodo" @click="inicializarCatalogo" type="button" id="btn-datos-plantilla" class="btn btn btn-info ml-2"><i class="fas fa-arrow-circle-down"></i>&nbsp;&nbsp;Iniciar</button>
                    </div>
                    <div id="contenedor-filtro-busqueda">
                        <div class="form-group" style=" margin-right: 1em; width: 25%;">
                            <h6>Municipio</h6>
                            <C010Municipios class="p-0 m-0" 
                                v-on:valorParaElPadre="cambioDeMunicipio" 
                                :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                :idDelInput="'FiltroTipoMuncipioFraccionamientos'" 
                                :parametros="{EntidadFederativaId: enumeraciones.pj.entidadesFederativas.Aguascalientes}" 
                                :valorDefinido="tipoMunicipioId" 
                                :key="'CMunicipioF' + contadorRenderCatalogos"></C010Municipios>
                        </div>
                        <div class="form-group" style="margin-right: 1em; width: 35%;">
                            <h6>Notificador asignado</h6>
                            <C020Notificadores 
                                class="p-0 m-0" 
                                v-on:valorParaElPadre="cambioTipoNotificadorFiltroBusqueda" 
                                :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                :idDelInput="catalogoNotificadores.ID" 
                                :parametros="catalogoNotificadores.parametros" 
                                :valorDefinido="catalogoNotificadores.valorDefinido" 
                                :key="catalogoNotificadores.KEY + catalogoNotificadores.contRender"
                                :filtrarPorJurisdiccion="true"></C020Notificadores>
                        </div>
                        <div class="form-group" style=" margin-right: 1em; width: 25%;">
                            <h6>Nombre</h6>
                            <input type="text" placeholder="Nombre del fraccionamiento" v-model="nombreFraccionamientoF" class="form-control" />
                        </div>
                        <div class="form-group" style="width: 15%;">
                            <h6>Código postal</h6>
                            <input type="text" placeholder="#######" v-model="codigoPostal" class="form-control" />
                        </div>
                    </div>
                    <hr style="height:2px;border:none;color:#FFF;background-color:#FFF;" class="mt-0"/>
                    <div>
                        <div id="inputs-filtro-memoria" class="form-inline justify-content-end">
                            <h6 for="f-busqueda" class="mr-sm-2">Buscar:</h6>
                            <input v-model="tablaFraccionamientos.buscarPor" type="text" id="f-busqueda" placeholder="Buscar en todas las columnas" class="form-control"/>
                        </div>
                        <div id="titulo-tabla">
                            <h4>Fraccionamientos registrados</h4>
                            <button id="btn-agregar-nuevoFraccionamiento" type="button" @click="mostrarFormulario" class="btn btn-primary"><i class="fas fa-plus-circle"></i>&nbsp;&nbsp;Agregar</button> 
                        </div>
                        <CTablaGenericaCedulas v-show="listaDeFraccionamientos.length > 0 && !cargandoFraccionamientos" class="table-responsive"
                            :idDelInput="ID_TABLA_FRACCIONAMIENTOS"
                            :encabezadosColumnas="encabezadosColumnas"
                            :accionesEnTabla="TABLA_FRACCIONAMIENTOS_ACCIONES"
                            v-on:accionesFuncionDeEditar="eventoEditarFraccionamiento"
                            v-on:accionFuncionEliminar="eventoEliminarFraccionamiento"
                            v-on:elementosSeleccionados="evtObtenerFraccionamientosSeleccionados"
                            :listaDeCedulas="listaDeFraccionamientos"
                            :ref="tablaFraccionamientos.REF"
                            :key="'K-TFraccionamientos-SINOJ' + contRenderTablaFraccionamientos"></CTablaGenericaCedulas>
                            <div v-if="listaDeFraccionamientos.length < 1 && !cargandoFraccionamientos" class="contenedor-sin-fraccionamientos" >
                                <div class="text-center">
                                    <i class="fas fa-map-marked-alt" style="font-size: 9em;"></i>
                                    <h6 style="margin-top:2em;">No se encontraron fraccionamientos.</h6>
                                </div>
                            </div>
                            <div v-if="cargandoFraccionamientos" class="contenedor-cargando" style="height: 300px ;">
                                <div class="text-center">
                                    <i class="fas fa-spinner fa-spin fa-5x"></i>
                                    <h4 class="mt-4">Cargando fraccionamientos</h4>
                                </div>
                            </div>
                            <div id="seccion-asignaciones" v-if="tablaFraccionamientos.listaParaAsignar.length > 0 || asignaciones.tabla.fraccionamientos.length > 0" 
                                    :class="[(tablaFraccionamientos.listaParaAsignar.length > 0) ? 'form-inline justify-content-between mt-4' : 'form-inline justify-content-end mt-4']">
                                <h6 v-if="tablaFraccionamientos.listaParaAsignar.length > 0">[#Fraccionamientos seleccionados {{ tablaFraccionamientos.listaParaAsignar.length }}]</h6>
                                <div>
                                    <button v-if="asignaciones.tabla.fraccionamientos.length > 0" @click="accionModalFormularioDeAsignacion({ accion: 'show' })" type="button" class="btn btn-light"><i class="fas fa-eye"></i>&nbsp;Ver lista de asignaciones</button>
                                    <button v-if="tablaFraccionamientos.listaParaAsignar.length > 0" class="btn btn-light ml-2" @click="agregarFraccionamientosAListaDeAsignacion"><i class="fas fa-plus"></i>&nbsp;Agregar a lista de asignación</button>
                                    <button v-if="tablaFraccionamientos.listaParaAsignar.length > 0" class="btn btn-light ml-2" @click="iniciarProcesoEliminacionDeAsignaciones"><i class="fas fa-minus-circle"></i>&nbsp;Remover asignaciones</button>
                                </div>
                            </div>
                    </div>
                    <!-- FORMULARIO DE FRACCIONAMIENTO -->
                    <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="formularo-fraccionamiento">
                        <div class="modal-dialog w-75 modal-dialog-centered">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">Formulario para registro de fraccionamiento</h5>
                                    <button id="btn-cerrar-formulario-alta-fraccionamiento" @click="limpiarFormularioAlta" class="close" data-dismiss="modal"><i class="fas fa-times-circle"></i></button>
                                </div>
                                <div class="modal-body pl-4 pr-4">
                                     <div id="contenedor-error-formulario" v-if="mostrarErroresFormularioAlta && mostrarAvisoErrores">
                                        <h6><i class="fas fa-exclamation-triangle text-danger"></i>&nbsp;Error en Formulario</h6>
                                        <span style="text-align: justify; display:block;">{{mensajeErrorFormularioAlta}}</span>
                                    </div>
                                    <div class="contenedor-color-negro" style="margin-top:1.5em;">
                                        <div>
                                            <h6>Municipio&nbsp;
                                                <i v-if="mostrarErroresFormularioAlta && municipioAltaEsCorrecto" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                                <i v-if="mostrarErroresFormularioAlta && !municipioAltaEsCorrecto" class="fas fa-times-circle text-danger font-size: 25px;"></i></h6>
                                            <C010Municipios class="p-0 m-0" 
                                                v-on:valorParaElPadre="cambioDeMunicipioAlta" 
                                                :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                                :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                                :idDelInput="'TipoMuncipioAltaFraccionamientos'" 
                                                :parametros="{EntidadFederativaId: enumeraciones.pj.entidadesFederativas.Aguascalientes}" 
                                                :valorDefinido="tipoMunicipioIdAlta" 
                                                :key="'CMunicipioAlta' + contadorRenderCatalogos"></C010Municipios>
                                        </div>
                                        <div style="margin-top:1em;">
                                            <h6>Nombre del fraccionamiento&nbsp;
                                                <i v-if="mostrarErroresFormularioAlta && (!this.cadenaEsVaciaONula(fraccionamientoManualmente) && this.construirErrorFormularioCampos())" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                                <i v-if="mostrarErroresFormularioAlta && (this.cadenaEsVaciaONula(fraccionamientoManualmente) && this.construirErrorFormularioCampos())" class="fas fa-times-circle text-danger font-size: 25px;"></i></h6>
                                            <input v-if="manualmente" type="text" placeholder="Ingrese el nombre del fraccionamiento" v-model="fraccionamientoManualmente" :class="[mostrarErroresFormularioAlta && (this.cadenaEsVaciaONula(fraccionamientoManualmente) && this.construirErrorFormularioCampos()) ? 'form-control border border-danger' : 'form-control']" />
                                        </div>
                                        <div style="margin-top:1em;">
                                            <h6>Código postal&nbsp;
                                                <i v-if="mostrarErroresFormularioAlta && (!this.cadenaEsVaciaONula(codigoPostalFraccionamiento) && this.construirErrorFormularioCampos())" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                                <i v-if="mostrarErroresFormularioAlta && (this.cadenaEsVaciaONula(codigoPostalFraccionamiento) && this.construirErrorFormularioCampos())" class="fas fa-times-circle text-danger font-size: 25px;"></i></h6>
                                            <input type="text" placeholder="Ingrese el nombre del fraccionamiento" v-model="codigoPostalFraccionamiento" :class="[mostrarErroresFormularioAlta && (this.cadenaEsVaciaONula(codigoPostalFraccionamiento) && this.construirErrorFormularioCampos()) ? 'form-control border border-danger' : 'form-control']" />
                                        </div>
                                       <!--  <div class="form-group mt-3">
                                            <h6>Notificador Asignado</h6>
                                            <C020Notificadores 
                                                class="p-0 m-0" 
                                                v-on:valorParaElPadre="cambioTipoNotificadorFormulario" 
                                                :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                                :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                                :idDelInput="formulario.catalogoNotificadores.ID" 
                                                :parametros="formulario.catalogoNotificadores.parametros" 
                                                :valorDefinido="formulario.catalogoNotificadores.valorDefinido" 
                                                :key="formulario.catalogoNotificadores.KEY + formulario.catalogoNotificadores.contRender"
                                                :filtrarPorJurisdiccion="true"></C020Notificadores>
                                        </div> -->
                                    </div>
                                    <div class="text-right" style="margin-top: 2em;">
                                         <button class="btn btn-primary" @click="eventoGuardarFraccionamiento"><i class="fas fa-save"></i>&nbsp;&nbsp;Guardar</button>
                                    </div>
                                </div>             
                            </div>
                        </div>
                    </div>
                    <!-- CONFIRMACION PARA INICIALIZAR CATALOGO -->
                    <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="aviso-confirmacion-inicializacion">
                        <div class="modal-dialog w-75 modal-dialog-centered">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">Aviso del sistema</h5>
                                </div>
                                <div class="modal-body pl-4 pr-4">
                                     <div id="contenedor-error-formulario">
                                        <h6><i class="fas fa-exclamation-triangle text-warning"></i>&nbsp;&nbsp;Inicialización de catalogo</h6>
                                        <span style="text-align: justify; display:block;">1) La información referente a los fraccionamientos será proporcionada por la base de datos SEPOMEX (servicio postal de méxico).</span>
                                        <span style="text-align: justify; display:block;">2) Se guardarán todos los fraccionamientos correspondientes al estado de aguascalientes en el catálogo de fraccionamientos SINOJ.</span>
                                        <span style="text-align: justify; display:block;">3) El proceso de registro puede demorar varios minutos debido al número de fraccionamientos, espere a que termine el proceso</span>
                                    </div>
                                    <div class="d-flex justify-content-end text-right mt-3">
                                         <button @click="evtInicializarCatalogoBD" class="btn btn btn-success"><i class="fas fa-save"></i>&nbsp;&nbsp;Aceptar</button>
                                         <button @click="evtCerrarAvisoInicializacion" class="btn btn-danger ml-2"><i class="fas fa-window-close"></i>&nbsp;&nbsp;Cancelar</button>
                                    </div>
                                </div>             
                            </div>
                        </div>
                    </div>
                    <!-- MODAL FORMULARIO DE ASIGNACION DE FRACCIONAMIENTOS -->
                    <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="formulario-asignacion">
                        <div class="modal-dialog modal-lg modal-dialog-centered">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">Asignacion de fraccionamientos a notificador&nbsp;&nbsp;<i class="fas fa-info-circle cursor-seleccion" @click="asignaciones.mostrarPasos = true"></i></h5>
                                    <button id="btn-cerrar-formulario-asignacion" class="close" data-dismiss="modal"><i class="fas fa-times-circle"></i></button>
                                </div>
                                <div class="modal-body pl-4 pr-4">
                                    <div v-if="asignaciones.mostrarPasos" id="pasos-asignacion-fraccionamientos" class="alert alert-dark" role="alert">
                                        <a href="#" class="close" @click="asignaciones.mostrarPasos = false">&times;</a>
                                        <h5><i class="fas fa-info-circle"></i>&nbsp;&nbsp;PASOS :</h5>
                                        <h6><strong>1)</strong> Selecciona a un notificador.</h6>
                                        <h6><strong>2)</strong> Verifica las fraccionamientos seleccionados antes de guardar las asignaciones.</h6>
                                        <h6><strong>3)</strong> En caso de requerirlo dar click en botón con el icono para remover un fraccionamiento de la lista <i class="fas fa-trash-alt"></i>.</h6>
                                        <h6><strong>4)</strong> Guarda el o los registros de las asignaciones con el botón <strong>Guardar</strong>.</h6>
                                    </div>
                                    <div class="w-50 mt-4">
                                        <div class="form-group">
                                            <C020Notificadores 
                                                class="p-0 m-0" 
                                                v-on:valorParaElPadre="cambioTipoNotificador" 
                                                :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                                :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                                :idDelInput="asignaciones.catalogoNotificadores.ID" 
                                                :parametros="asignaciones.catalogoNotificadores.parametros" 
                                                :valorDefinido="asignaciones.catalogoNotificadores.valorDefinido" 
                                                :key="asignaciones.catalogoNotificadores.KEY + asignaciones.catalogoNotificadores.contRender"
                                                :filtrarPorJurisdiccion="true"></C020Notificadores>
                                            <i v-if="asignaciones.mostrarError">(*) Debes seleccionar un notificador</i>
                                        </div>
                                    </div>
                                    <div class="mt-4">
                                        <h6>Listado de fraccionamientos&nbsp;&nbsp;|&nbsp;&nbsp;
                                            <i v-tooltip:right="'Limpiar lista de asignaciones'" class="fas fa-trash-alt cursor-seleccion" @click="asignaciones.tabla.fraccionamientos = []"></i>
                                        </h6>
                                        <CTablaGenericaCedulas class="table-responsive"
                                            :idDelInput="asignaciones.tabla.ID"
                                            :encabezadosColumnas="asignaciones.tabla.ENCABEZADOS"
                                            :accionesEnTabla="asignaciones.tabla.ACCIONES"
                                            :listaDeCedulas="asignaciones.tabla.fraccionamientos"
                                            v-on:accionFuncionEliminar="evtRemoverFraccionamientoParaAsignacion"
                                            :ref="asignaciones.tabla.REF"
                                            :key="asignaciones.tabla.KEY + asignaciones.tabla.contRender"></CTablaGenericaCedulas>
                                    </div>
                                </div>  
                                <div class="modal-footer">
                                    <div class="d-flex justify-content-end">
                                        <button  type="button" @click="iniciarProcesoParaGuardarAsignaciones" class="btn btn-light"><i class="fas fa-save"></i>&nbsp;&nbsp;Guardar</button>
                                    </div>
                                </div>           
                            </div>
                        </div>
                    </div>
                </div>
             </div>
        </div>
    </div>
</template>
<script>
import enumeraciones from '@/../static/js/enumeraciones'
import sistemas from '@/../static/js/sistemas'
import comun from "@/../static/js/comun"
import catalogos from '@/../static/js/catalogos'
import api from '@/../static/js/api'
import axios from 'axios'
import { tooltipF } from '@/../static/js/tooltip/ToolTipDirective.js'

export default {
    components: {
        CTablaGenericaCedulas: sistemas.SINOJ.CTablaGenericaCedulas,
        C010Municipios: catalogos.PJ.C010Municipios,
        C020Notificadores: catalogos.SINOJ.C020Notificadores
    },
    directives: {
        tooltipF
    },
    data() {
        return {
            enumeraciones,
            zona: '-1',
            notificador: '-1',
            codigoPostal: null,
            ID_TABLA_FRACCIONAMIENTOS: 'tablaFraccionamientosAdministracion',
            contRenderTablaFraccionamientos: 0,
            encabezadosColumnas: ['Folio','Nombre','Código postal','Municipio','Estatus','Asignado a',''],
            TABLA_FRACCIONAMIENTOS_ACCIONES: {motrarAcciones: true,check: true, eliminar: true, editar: true,imprimir: false, ver: false},
            listaDeFraccionamientos: [],
            listaDeFraccionamientosBD: [],
            municipio:'-1',
            nombreFraccionamiento: '-1',
            codigoPostalFraccionamiento: '',
            zonaAsignada: '-1',
            conCatalogos: false,
            manualmente: true,
            modoEdicion: false,
            estatus: '-1',
            fraccionamientoManualmente: null,
            municipioManualmente: null,
            tipoMunicipioId: 1,
            contadorRenderCatalogos: 0,
            nombreFraccionamientoF: null,
            tipoMunicipioIdAlta: -1,
            mostrarAvisoErrores: false,
            mostrarErroresFormularioAlta: false,
            mensajeErrorFormularioAlta: 'Se detectaron campos incorrectos',
            municipioAltaEsCorrecto: false,
            cargandoFraccionamientos: true,
            fraccionamientoSeleccionado: null,
            modoEdicion: false,
            catalogoNotificadores: {
                ID: 'IDCTipoNotificadorFormFRACC_BUSQUEDA',
                KEY: 'CTipoNotificadorFormFRACC_BUSQUEDA',
                parametros: { NotififadorId: null, ZonaId: null, ConInactivos: false, ConZona: false, ConCedulas: false, ConSalidas:false },
                valorDefinido: -1,
                contRender: 0,
                seleccionado: null
            },
            SEPOMEX: {
                filtros: {
                    nombre: null,
                    municipio: null,
                    tipoMunicipioId: -1,
                    municipioBusquedaId: -1,
                    contadorRenderCatalogos: 0,
                    codigoPostal: null,
                    buscarPor: null,
                    cargandoFraccionamientos: false,
                    mostrarErrores: false
                },
                tablaRegistros: {
                    ID_TABLA: 'TablaResultadosSEPOMEX',
                    render: 0,
                    encabezados: ['#','Nombre','Código postal','Municipio','']
                },
                seccion: {
                    visualizar: false
                },
                fraccionamientosSEPOMEX: [],
                fraccionamientosSEPOMEXalta: [],
                fraccionamientosSEPOMEXFiltrados: [],
                contadorFraccionamientos: 1,
                busquedaTerminada: false,
                numFraccGuardar: 0,
                fraccARegistrar: []
            },
            municipiosAgsCatalogo: [],
            permisos: {
                administracionTotal: false,
                revisoPermisos: false
            },
            tablaFraccionamientos: {
                listaParaAsignar: [],
                seleccionados: [],
                buscarPor: null,
                REF: 'TablaDeFraccionamientosSINOJ',
                numeroDeAsignaciones: 0
            },
            asignaciones: {
                lista: [],
                catalogoNotificadores: {
                    ID: 'IDCTipoNotificadorFRACC',
                    KEY: 'CTipoNotificadorFRACC',
                    parametros: { NotififadorId: null, ZonaId: null, ConInactivos: false, ConZona: false, ConCedulas: false, ConSalidas:false },
                    valorDefinido: -1,
                    contRender: 0,
                    seleccionado: null
                },
                tabla: {
                    ID: 'TablaParaAsignacionID',
                    REF: 'REFTablaParaAsignacionID',
                    ENCABEZADOS: ['Folio','Nombre','Código postal','Municipio','Estatus',''],
                    ACCIONES: { motrarAcciones: true,check: false, eliminar: true, editar: false,imprimir: false, ver: false },
                    fraccionamientos: []
                },
                mostrarPasos: false,
                mostrarError: false
            },
            formulario: {
                catalogoNotificadores: {
                    ID: 'IDCTipoNotificadorFormFRACC',
                    KEY: 'CTipoNotificadorFormFRACC',
                    parametros: { NotififadorId: null, ZonaId: null, ConInactivos: false, ConZona: false, ConCedulas: false, ConSalidas:false },
                    valorDefinido: -1,
                    contRender: 0,
                    seleccionado: null
                },
            }
        }
    },
    methods: {
        evtRemoverFraccionamientoParaAsignacion: function(evento) {
            const ID_COMPUESTO_FRACCIONAMIENTO = evento.target.getAttribute('id').split('-');
            const FRACCIONAMIENTO_ID = parseInt(ID_COMPUESTO_FRACCIONAMIENTO[(ID_COMPUESTO_FRACCIONAMIENTO.length -1)]);
            this.asignaciones.tabla.fraccionamientos = this.asignaciones.tabla.fraccionamientos.filter(fAsig => fAsig.Folio != FRACCIONAMIENTO_ID);
        },
        iniciarProcesoEliminacionDeAsignaciones: async function() {
            let peticionAPI = await Promise.resolve(this.crearPeticionEliminacionDeAsignaciones());
            let { fraccionamientos } = await Promise.resolve(this.removerAsignacionesDeFraccionamientosBD({ peticion: peticionAPI }));
            this.tablaFraccionamientos.listaParaAsignar = [];
            this.cargandoFraccionamientos = true;
            /* this.cargarFraccionamientosRegistradosBD(); */
            await Promise.resolve(this.actaulizarInformacionDeFraccionamientos({ fraccionamientosDB: fraccionamientos }));
            this.cargandoFraccionamientos = false;
        },
        crearPeticionEliminacionDeAsignaciones: async function() {
            let peticion = {};
            let fraccionamientos = this.tablaFraccionamientos.listaParaAsignar.map(a => {
                /* let fraccionamiento = {};
                fraccionamiento.FraccionamientoId = a.folio;
                fraccionamiento.CodigoPostal = -1;
                fraccionamiento.Activo = true; */
                let fraccionamiento = this.listaDeFraccionamientosBD.find(f => f.FraccionamientoId == a.folio);
                return fraccionamiento;
            })
            peticion.Fraccionamientos = fraccionamientos;
            peticion.esPrueba = false;
            return peticion;
        },
        removerAsignacionesDeFraccionamientosBD: async function({ peticion, conCargandoInformacion = true }) { 
            let informacionProceso = { conError: true, fraccionamientos: [] };
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_ELIMINAR = api.SINOJ.sistema.administracion.fraccionamientos.EliminarAsignaciones;
                let urlApi = SERVIDOR + METODO_API_ELIMINAR;
                let peticionAPI = peticion;
                let peticionArchivos = false;
                let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
                if(conCargandoInformacion)
                    comun.SeEstaCargandoInformacion(true);
                const RESPUESTA_DE_PETICION = await axios.post(urlApi, peticionAPI, headerPeticion);
                const DATOS_RESPUESTA = await RESPUESTA_DE_PETICION.data;
                let { SiHayError, Error, Satisfactorio, Fraccionamientos } = DATOS_RESPUESTA;
                if (SiHayError) {
                    let mensajeError = Error.Mensaje;
                    comun.mensajeDeAlerta(mensajeError);
                    console.log(Error);
                } 
                else {
                    if(conCargandoInformacion)
                        comun.SeEstaCargandoInformacion(false);
                    comun.mensajeDeAlerta(Satisfactorio);
                    informacionProceso.conError = false;
                    informacionProceso.fraccionamientos = Fraccionamientos;
                }
            }
            catch(excepcion) {
                if(conCargandoInformacion)
                    comun.SeEstaCargandoInformacion(false);
                console.log(excepcion);
                comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
            }
            return informacionProceso;
        },
        iniciarProcesoParaGuardarAsignaciones: async function() {
            if(this.campoRequeridoEsValido(this.asignaciones.catalogoNotificadores.valorDefinido)) {
                this.accionModalFormularioDeAsignacion({ accion: 'hide' });
                let peticionAPI = await Promise.resolve(this.obtenerPeticionGuardarAsignaciones());
                let { fraccionamientos } = await Promise.resolve(this.guardarAsignacionesDeFraccionamientosBD({ peticion: peticionAPI }));
                const CON_TABLA_FRACCIONAMIENTOS = false;
                this.limpiarFormularioDeAsignacion(CON_TABLA_FRACCIONAMIENTOS);
                this.cargandoFraccionamientos = true;
                //this.cargarFraccionamientosRegistradosBD();
                await Promise.resolve(this.actaulizarInformacionDeFraccionamientos({ fraccionamientosDB: fraccionamientos }));
                this.cargandoFraccionamientos = false;
            }
            else {
                this.asignaciones.mostrarError = true;
            }
        },
        actaulizarInformacionDeFraccionamientos: async function({ fraccionamientosDB, nuevoElemento = false }) {
            if(this.campoRequeridoEsValido(fraccionamientosDB)) {
                if(nuevoElemento) {
                    const NUEVO_FRACCIONAMIENTO_FORMATO_TABLA = this.obtenerFraccionamientoFormatoTabla({ fraccionamientoDB: fraccionamientosDB[0] });
                    this.listaDeFraccionamientos.push(NUEVO_FRACCIONAMIENTO_FORMATO_TABLA);
                }
                else {
                    fraccionamientosDB.forEach(f => {
                        let fraccFormatoTabla = this.obtenerFraccionamientoFormatoTabla({ fraccionamientoDB: f });
                        const INDEX_FILA = this.listaDeFraccionamientos.findIndex(fT => fT.Folio == fraccFormatoTabla.Folio);
                        this.listaDeFraccionamientos[INDEX_FILA] = fraccFormatoTabla;
                        /* this.$refs[this.tablaFraccionamientos.REF].actualizarFila(fraccFormatoTabla); */
                    });
                }
                this.contRenderTablaFraccionamientos ++;
            }
        },
        obtenerFraccionamientoFormatoTabla: function({ fraccionamientoDB }) {
            let fraccionamiento = {};
            fraccionamiento.Folio = fraccionamientoDB.FraccionamientoId;
            fraccionamiento.Nombre = fraccionamientoDB.Nombre;
            fraccionamiento.CodigoPostal = fraccionamientoDB.CodigoPostal;
            fraccionamiento.Municipio = fraccionamientoDB.Municipio.Nombre;
            fraccionamiento.Estatus = (fraccionamientoDB.Activo) ? 'Activo' : 'Inactivo';
            fraccionamiento.asignacion = this.obtenerNombreNotificador(fraccionamientoDB.NotificadoresAsignados);
            return fraccionamiento;
        },
        obtenerPeticionGuardarAsignaciones: async function() {
            let peticion = {};
            const { valorDefinido } = this.asignaciones.catalogoNotificadores;
            let asignaciones = this.asignaciones.tabla.fraccionamientos.map(fAsig => {
                let asignacionObj = {};
                asignacionObj.AsignacionDeFraccionamientoId = -1;
                asignacionObj.Activo = -1;
                // se crea objeto de notificador
                let notificadorObj = {
                    NotificadorId: valorDefinido,
                    Activo: true // dato no relevante solo enviar para no ocacionar algun problema al momento de convertir la peticion
                };
                asignacionObj.Notificador = notificadorObj;
                // se crea objeto de fraccionamiento
                /* let fraccionamientoObj = {
                    FraccionamientoId: fAsig.Folio,
                    CodigoPostal: -1,
                    Activo: true
                }; */
                asignacionObj.Fraccionamiento = this.listaDeFraccionamientosBD.find(f => f.FraccionamientoId == fAsig.Folio);
                return asignacionObj;
            });
            peticion.Asignaciones = asignaciones;
            peticion.esPrueba = false;
            return peticion;
        },
        guardarAsignacionesDeFraccionamientosBD: async function({ peticion, conCargandoInformacion = true }) { 
            let informacionProceso = { conError: true, fraccionamientos: [] };
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_GUARDAR = api.SINOJ.sistema.administracion.fraccionamientos.GuardarAsignaciones;
                let urlApi = SERVIDOR + METODO_API_GUARDAR;
                let peticionAPI = peticion;
                let peticionArchivos = false;
                let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
                if(conCargandoInformacion)
                    comun.SeEstaCargandoInformacion(true);
                const RESPUESTA_DE_PETICION = await axios.post(urlApi, peticionAPI, headerPeticion);
                const DATOS_RESPUESTA = await RESPUESTA_DE_PETICION.data;
                let { SiHayError, Error, Satisfactorio, Fraccionamientos } = DATOS_RESPUESTA;
                if (SiHayError) {
                    let mensajeError = Error.Mensaje;
                    comun.mensajeDeAlerta(mensajeError);
                    console.log(Error);
                } 
                else {
                    if(conCargandoInformacion)
                        comun.SeEstaCargandoInformacion(false);
                    comun.mensajeDeAlerta(Satisfactorio);
                    informacionProceso.conError = false;
                    informacionProceso.fraccionamientos = Fraccionamientos;
                }
            }
            catch(excepcion) {
                if(conCargandoInformacion)
                    comun.SeEstaCargandoInformacion(false);
                console.log(excepcion);
                comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
            }
            return informacionProceso;
        },
        limpiarFormularioDeAsignacion: function(conTablaDeFraccionamientos = true) {
            this.asignaciones.tabla.fraccionamientos = [];
            this.asignaciones.catalogoNotificadores.valorDefinido = -1;
            this.asignaciones.catalogoNotificadores.contRender ++;
        },
        evtMostrarPasos: function() {
             $('#pasos-asignacion-fraccionamientos').addClass('show');
        },
        agregarFraccionamientosAListaDeAsignacion: function() {
            let fraccSeleccionados = this.tablaFraccionamientos.listaParaAsignar.filter(f => f.enviar);
            fraccSeleccionados.forEach(fs => {
                let fraccionamiento = this.listaDeFraccionamientos.find(fm => fm.Folio == fs.folio);
                if(this.campoRequeridoEsValido(fraccionamiento) && !this.asignaciones.tabla.fraccionamientos.some(fAsig => fAsig.Folio == fraccionamiento.Folio))
                    this.asignaciones.tabla.fraccionamientos.push(fraccionamiento)
            });
            
            this.$nextTick(() => { 
                this.$refs[this.tablaFraccionamientos.REF].evtLimpiarSeleccionCPadre();
                this.tablaFraccionamientos.listaParaAsignar = [];
            });
            comun.mensajeDeAlerta('Los fraccionamientos se agregaron de manera correcta a lista');
        },
        accionModalFormularioDeAsignacion: function({ accion }) {
            $("#formulario-asignacion").modal(accion);
        },
        evtObtenerFraccionamientosSeleccionados: function(evento) {
            this.tablaFraccionamientos.listaParaAsignar = evento.filter(f => f.enviar);
            this.tablaFraccionamientos.numeroDeAsignaciones = this.tablaFraccionamientos.listaParaAsignar.filter(f => f.enviar).length;
        },
        cambioTipoNotificador: function(evento) {
            this.asignaciones.catalogoNotificadores.valorDefinido = parseInt(evento.target.value);
        },
        cambioTipoNotificadorFiltroBusqueda: function(evento) {
            this.catalogoNotificadores.valorDefinido = parseInt(evento.target.value);
        },
        cambioTipoNotificadorFormulario: function(evento) {
            this.formulario.catalogoNotificadores.valorDefinido = parseInt(evento.target.value);
        },
        /**
         * funcion encargado de iniciar el proceso para inicializar el catalogo de fraccionamientos. 
         */
        evtInicializarCatalogoBD: async function() {
           try {
                this.SEPOMEX.fraccionamientosSEPOMEXalta = [];
                $('#aviso-confirmacion-inicializacion').modal('hide');
                await this.obtenerFraccionamientosSEPOMEX();
                //console.log('todos::',this.SEPOMEX.fraccionamientosSEPOMEXalta);
                await Promise.resolve(this.cargaCatalogoDeMunicipios());
                //console.log('municat::',this.municipiosAgsCatalogo);
                let peticion = await this.crearPeticionInicializacionCatalogo();
                //console.log('peticionAprovisionamiento::',peticion); 
                const ES_INICIALIZACION_CATALOGO = false;
                this.guardarFraccSEPOMEXenCatalogo(peticion,ES_INICIALIZACION_CATALOGO);
           }
           catch(exception) {
               comun.mensajeDeAlerta('El ocurrio un error en el proceso, vuelve a intentar')
           }
        },
        /**
         * funcion encargado de crear objeto con la estructura de la peticion para carga total de los fraccionamientos de SEPOMEX. 
         * @returns {Promise} objetoPeticion [objeto con listado de fraccionamientos]
         * @see {@link obtenerIdMunicipioPJ}
         */
        crearPeticionInicializacionCatalogo: async function() {
            return new Promise((resolve, reject) => {
                let peticionAPI = {};
                let fraccionamientosObj = [];
                this.SEPOMEX.fraccionamientosSEPOMEXalta.forEach(fr => {
                    let fraccionamientoObj = {
                        FraccionamientoId: -1,
                        Nombre: fr.Nombre,
                        CodigoPostal: fr.CodigoPostal,
                        Activo: true,
                        Municipio: { MunicipioId: this.obtenerIdMunicipioPJ(fr.Municipio) },
                        Domicilios: null
                    }
                    fraccionamientosObj.push(fraccionamientoObj);
                });
                peticionAPI.Fraccionamientos = fraccionamientosObj;
                peticionAPI.esPrueba = false;
                resolve(peticionAPI);
             });
        },
        /**
         * funcion encargado de convertir el municipio obtenido en SEPOMEX a el id del municpio de los catalogos de PJ. 
         * @param {String} nombreMunicipio [nombre de municipio]
         * @returns {Number} idMunicipioPj []
         * @see {@link campoRequeridoEsValido}
         */
        obtenerIdMunicipioPJ: function(nombreMunicipio) {
            let idEnPJ = 1; // valor default aguascalientes
            // la API de SEPOMEX tienen diferentes los nombre de rincon, tepezala y cosio, siempre remplazar por los de el catalogo de pj
            try {
                if(nombreMunicipio == 'Rincón de Romos')
                    nombreMunicipio ='RINCÓN DE LOS ROMOS';
                else if(nombreMunicipio == 'Tepezalá')
                    nombreMunicipio ='TEPEZALA';
                else if(nombreMunicipio == 'Cosío')
                    nombreMunicipio ='COSIO';
                
                let municipioPJ = this.municipiosAgsCatalogo.find(mca => mca.Nombre.toUpperCase() == nombreMunicipio.toUpperCase());
                if(this.campoRequeridoEsValido(municipioPJ)) {
                    idEnPJ = municipioPJ.MunicipioId;
                }
            }
            catch(exception) {
                console.log('exc::municipio',exception)
            }
            return idEnPJ;
        },
        evtCerrarAvisoInicializacion: function() {
            $('#aviso-confirmacion-inicializacion').modal('hide');
        },
        inicializarCatalogo: function() {
            $('#aviso-confirmacion-inicializacion').modal('show');
        },
        /**
         * funcion encargado de limpiar los valores de la seccion SEPOMEX. 
         */
        evtCerrarSeccionSEPOMEX: function() {
            this.SEPOMEX.tablaRegistros.render ++;
            this.SEPOMEX.filtros.municipio = null;
            this.SEPOMEX.filtros.tipoMunicipioId = -1;
            this.SEPOMEX.filtros.municipioBusquedaId = -1;
            this.SEPOMEX.filtros.contadorRenderCatalogos ++;
            this.SEPOMEX.filtros.buscarPor = '';
            this.SEPOMEX.fraccionamientosSEPOMEXFiltrados = [];
            this.SEPOMEX.fraccionamientosSEPOMEX = [];
            this.SEPOMEX.fraccARegistrar = [];
            this.SEPOMEX.filtros.mostrarErrores = false;
            this.SEPOMEX.seccion.visualizar = false;
        },
        /**
         * funcion encargado de iniciar el proceso para guardar los fraccionamientos seleccionados en la seccon SEPOMEX. 
         * @see {@link crearPeticionFraccSEPOMEX}
         * @see {@link guardarFraccSEPOMEXenCatalogo}
         */
        evtGuardarFraccionamientosSEPOMEX: async function() {
            let peticion = await this.crearPeticionFraccSEPOMEX();
            //console.log('valorPeticion::',peticion);
            const ES_INICIALIZACION_CATALOGO = false;
            this.guardarFraccSEPOMEXenCatalogo(peticion,ES_INICIALIZACION_CATALOGO);
        },
        /**
         * funcion encargado de mapear los objetos de los fraccionamientos SEPOMEX a la peticion para guardar fraccionameintos seleccionados
         * @returns {Promise} objetoPeticion [peticion]
         */
        crearPeticionFraccSEPOMEX: async function() { debugger
             return new Promise((resolve, reject) => {
                let peticionAPI = {};
                let fraccionamientosObj = [];
                this.SEPOMEX.fraccARegistrar.filter(far => far.enviar).forEach(fr => {
                    let fraccSeleccionado = this.SEPOMEX.fraccionamientosSEPOMEX.find(f => f.Folio == fr.folio);
                    if(fraccSeleccionado != null || fraccSeleccionado != undefined) {
                        let fraccionamientoObj = {
                            FraccionamientoId: -1,
                            Nombre: fraccSeleccionado.Nombre,
                            CodigoPostal: fraccSeleccionado.CodigoPostal,
                            Activo: true,
                            Municipio: { MunicipioId: this.SEPOMEX.filtros.municipioBusquedaId },
                            Domicilios: null
                        }
                        fraccionamientosObj.push(fraccionamientoObj);
                    }
                });
                peticionAPI.Fraccionamientos = fraccionamientosObj;
                peticionAPI.esPrueba = false;
                resolve(peticionAPI);
             });
        },
        /**
         * funcion encargado de guardar fraccioanmeintos de SEPOMEX en catalogo de fraccionamientos SINOJ. 
         * @param {Object} peticionAPI [peticion para metodo API]
         * @param {Boolean} resgistrarTodo [indica si es para inicializar catalogo]
         * @see {@link obtenerIdMunicipioPJ}
         */
        guardarFraccSEPOMEXenCatalogo: function(peticionAPI, resgistrarTodo) {
            const SERVIDOR = api.conexion;
            const METODO_API_AGREGAR = api.SINOJ.sistema.administracion.fraccionamientos.GuardarFraccionamientos;
            let urlApi = SERVIDOR + METODO_API_AGREGAR;
            let peticionArchivos = false;
            let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
            comun.SeEstaCargandoInformacion(true);
            axios.post(urlApi, peticionAPI, headerPeticion)
                    .then(respuesta => {            
                        if (respuesta.data.SiHayError) {
                            let mensajeError = respuesta.data.Error.Mensaje;
                            console.log(mensajeError);
                            comun.mensajeDeAlerta(mensajeError, null, null);
                        } 
                        else {
                            //console.log("carga masiva ejecuto bien :: " + respuesta.data);
                            if(!resgistrarTodo) {
                                this.SEPOMEX.tablaRegistros.render ++;
                                this.SEPOMEX.fraccARegistrar = [];
                            }
                            else {
                                this.SEPOMEX.fraccionamientosSEPOMEXalta = [];
                            }
                            comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
                        }
                        comun.SeEstaCargandoInformacion(false);
                    })
                    .catch(excepcion => {
                        comun.SeEstaCargandoInformacion(false);
                        console.log(excepcion);
                        comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
                    }
            ); 
        },
        /**
         * funcion encargado de guardar fraccioanmeintos de SEPOMEX en catalogo de fraccionamientos SINOJ. 
         * @param {Object} evento [evento emitido por el catalogo de municipios seccion SEPOMEX]
         */
        evtFraccSEPOMEXSeleccionados: function(evento) {
            this.SEPOMEX.fraccARegistrar = evento;
            this.SEPOMEX.numFraccGuardar = this.SEPOMEX.fraccARegistrar.filter(f => f.enviar).length;
            //console.log('sel::',this.SEPOMEX.fraccARegistrar);
        },
        /**
         * funcion encargado de limpiar los filtrado en memoria de los rultados SEPOMEX.
         */
        evtResetearFiltros: function() {
           this.SEPOMEX.tablaRegistros.render ++;
           this.SEPOMEX.filtros.buscarPor = '';
           this.SEPOMEX.fraccionamientosSEPOMEXFiltrados = this.SEPOMEX.fraccionamientosSEPOMEX;
           this.SEPOMEX.fraccARegistrar = [];
        },
        /**
         * funcion encargado de hacer el filtrado en memoria de los resultados SEPOMEX.
         * @param {Object} e [eventos emitido de captura de informacion]
         * @see {@link predicateFiltradoPorSimilitud}
         */
        filtrarFraccMemoria: function(e) {
            //console.log('comienzza filtrado');
            // filtra por columnas
            this.SEPOMEX.tablaRegistros.render ++;
            this.SEPOMEX.fraccARegistrar = [];
            this.SEPOMEX.fraccionamientosSEPOMEXFiltrados = this.SEPOMEX.fraccionamientosSEPOMEX
                .filter(c => {
                    return Object.values(c).some(valorColumna => this.predicateFiltradoPorSimilitud(valorColumna, this.SEPOMEX.filtros.buscarPor));
                });
        },
         /**
         * funcion encargado de comparar dos valores por coincidencia.
         * @param {String} elementoAEvaluar [valor que se va a comparar]
         * @param {String} compararCon [valor con el que se va a comparar]
         * @see {@link campoRequeridoEsValido}
         */
        predicateFiltradoPorSimilitud: function(elementoAEvaluar,compararCon) { 
            if(this.campoRequeridoEsValido(compararCon)) {
            if(elementoAEvaluar.toString().toUpperCase().startsWith(compararCon.toString().toUpperCase()))
                return true;
            else
                return false;
            }
            else
                return true;
        },
         /**
         * funcion encargado de consultar fraccionamientos con la API SEPOMEX filtrando por municipio.
         * @see {@link campoRequeridoEsValido}
         * @see {@link fraccionamientosConFiltrosSEPOMEX}
         */
        busquedaFraccionamientosSEPOMEX: async function() {
            if(this.campoRequeridoEsValido(this.SEPOMEX.filtros.tipoMunicipioId)) {
                this.SEPOMEX.filtros.mostrarErrores = false;
                this.SEPOMEX.tablaRegistros.render ++;
                this.SEPOMEX.fraccARegistrar = [];
                this.SEPOMEX.filtros.municipioBusquedaId = this.SEPOMEX.filtros.tipoMunicipioId;
                $("#filtros-input-fracc-memoria input").off("change paste keyup");
                await Promise.resolve(this.fraccionamientosConFiltrosSEPOMEX());
            }
            else {
                this.SEPOMEX.filtros.mostrarErrores = true;
                comun.mensajeDeAlerta('la busqueda sin filtros puede tardar mas de 10 minutos, es recomendable tener al menos el municipio seleccionado en la seccion de los filtros');
            }
        },
         /**
         * funcion encargado de iniciar el processo para la busqueda en SEPOMEX cuando la busqueda tenga algun filtro.
         * @see {@link fraccionamientosPorMunicipio}
         * @see {@link filtrarFraccMemoria}
         */
        fraccionamientosConFiltrosSEPOMEX: async function() {
            // se limpian variables de filtrado
           this.SEPOMEX.fraccionamientosSEPOMEXFiltrados = [];
           this.SEPOMEX.fraccionamientosSEPOMEX = [];
           this.SEPOMEX.contadorFraccionamientos = 1;
           this.SEPOMEX.filtros.buscarPor = '';
           try {
                comun.SeEstaCargandoInformacion(true);
                const ES_PARA_INICILIZAR = false;
                await Promise.resolve(this.fraccionamientosPorMunicipio(this.SEPOMEX.filtros.municipio, ES_PARA_INICILIZAR));
                this.SEPOMEX.fraccionamientosSEPOMEXFiltrados = this.SEPOMEX.fraccionamientosSEPOMEX;
                comun.SeEstaCargandoInformacion(false);
                $("#filtros-input-fracc-memoria input").on("change paste keyup", (e) => {
                    if(this.SEPOMEX.fraccionamientosSEPOMEX.length > 0 && !this.SEPOMEX.filtros.cargandoFraccionamientos) {
                        this.filtrarFraccMemoria(e);
                    }
                });
           }
           catch(exception) {
               comun.SeEstaCargandoInformacion(false);
               comun.mensajeDeAlerta('No se encontraron resultados');
           }
        },
        /**
         * funcion encargado de obtener todos los fraccionamientos de SEPOMEX sin filtros.
         * @see {@link fraccionamientosPorMunicipio}
         */
        obtenerFraccionamientosSEPOMEX: async function() { debugger
            this.SEPOMEX.fraccionamientosSEPOMEX = [];
            this.SEPOMEX.busquedaTerminada = false;
            this.SEPOMEX.contadorFraccionamientos = 1;
            const ES_PARA_INICIALIZAR_CATALOGO = true;
            comun.SeEstaCargandoInformacion(true);
            const { GET_MUNICIPIOS, GET_CP_MUNICIPIO, GET_FRACC_CP, GET_COMPUESTO } = enumeraciones.sinoj.fraccionamientos.api.metodos;
            // Se crea ruta base para obtener los municipios de aguascalientes
            const URL_MUNICIPIOS = `${enumeraciones.sinoj.fraccionamientos.api.URL_BASE}${GET_MUNICIPIOS}Aguascalientes?${ enumeraciones.sinoj.fraccionamientos.api.TOKEN }`;
            // Se obtienen los municipios
            const PETICION_MUNICIPIOS = await axios.get(URL_MUNICIPIOS);
            let respuestaMunicipios = await PETICION_MUNICIPIOS.data;
            const MUNICIPIOS_AGS = respuestaMunicipios.response.municipios;
            //console.log('municipios::', MUNICIPIOS_AGS);
            // se valida que la peticion obtenga municipios
            if(MUNICIPIOS_AGS != null && MUNICIPIOS_AGS != undefined && MUNICIPIOS_AGS.length > 0) {
                // se realiza ciclo para obtener cp de los municipios del listado
                for(let i in MUNICIPIOS_AGS) {
                    let municipio = MUNICIPIOS_AGS[i];
                    await Promise.resolve(this.fraccionamientosPorMunicipio(municipio, ES_PARA_INICIALIZAR_CATALOGO));
                }
            }
             this.SEPOMEX.busquedaTerminada = true;
             comun.SeEstaCargandoInformacion(false);
        },
        /**
         * funcion encargado de obtener de llamar API y obtener los fraccionamientos por municipio.
         * @param {String} municipioTmp [municipio con el que se realizara la busqueda]
         * @param {Boolean} todosLosFraccionamientos [indica si es para inicializar catalogo]
         * @see {@link construirFraccionamientos}
         */
        fraccionamientosPorMunicipio: async function(municipioTmp, todosLosFraccionamientos) {
            let municipio = (municipioTmp == 'RINCÓN DE LOS ROMOS') ? 'Rincón de Romos' : municipioTmp;
            this.SEPOMEX.filtros.cargandoFraccionamientos = (todosLosFraccionamientos) ? this.SEPOMEX.filtros.cargandoFraccionamientos : true;
            const { GET_MUNICIPIOS, GET_CP_MUNICIPIO, GET_FRACC_CP, GET_COMPUESTO } = enumeraciones.sinoj.fraccionamientos.api.metodos;
            // Se crea ruta para consultar cp del municipio
            const URL_CP_MUNICIPIO = `${enumeraciones.sinoj.fraccionamientos.api.URL_BASE}${GET_COMPUESTO}Aguascalientes?municipio=${municipio}&${ enumeraciones.sinoj.fraccionamientos.api.TOKEN }`;
            //console.log('url::',URL_CP_MUNICIPIO);
            const PETICION_CP = await axios.get(URL_CP_MUNICIPIO);
            let respuestaCpMunicipio = await PETICION_CP.data;
            //console.log('municipio:' + municipio + '::', respuestaCpMunicipio);
            let cpMunicipio = respuestaCpMunicipio.response.cp;
            if(cpMunicipio != null && cpMunicipio != undefined && cpMunicipio.length > 0) {
                // se buscan los feraccionamiento por cada cp del municipio
                for(let j in cpMunicipio) {
                    let cp = cpMunicipio[j];
                    const URL_CP_FRACCIONAMIENTOS = `${enumeraciones.sinoj.fraccionamientos.api.URL_BASE}${GET_FRACC_CP}${cp}?${ enumeraciones.sinoj.fraccionamientos.api.TOKEN }`;
                    const PETICION_FRACCIONAMIENTOS = await axios.get(URL_CP_FRACCIONAMIENTOS);
                    let respuestaCpFraccionamientos = await PETICION_FRACCIONAMIENTOS.data;
                    let fraccionamientosCp = respuestaCpFraccionamientos.response.colonia;
                    let objeFraccionamientos = await this.construirFraccionamientos(municipio, cp, fraccionamientosCp, todosLosFraccionamientos);
                    //console.log('cp::col::',this.SEPOMEX.fraccionamientosSEPOMEX);
                }
            }
            this.SEPOMEX.filtros.cargandoFraccionamientos = false;
        },
        /**
         * funcion encargado de mapear informacion de SEPOMEX a objeto con la estructura de la entidad fraccionamientos.
         * @param {String} municipio [municipio de los fraccionamientos]
         * @param {String} cp [codigo postal de los fraccionamientos]
         * @param {String} fraccionamientos [fraccionamientos obtenidos por SEPOMEX]
         * @param {Boolean} todosLosFraccionamientos [indica si es para inicializar catalogo]
         * @returns {Promise} lista [lista de fraccionameintos]
         */
        construirFraccionamientos: async function(municipio, cp, fraccionamientos, todosLosFraccionamientos) {
            return new Promise((resolve, reject) => {
                if(fraccionamientos != null && fraccionamientos != undefined && fraccionamientos.length > 0) {
                    fraccionamientos.forEach(f => {
                        let fraccionamiento = {};
                        fraccionamiento.Folio = this.SEPOMEX.contadorFraccionamientos;
                        fraccionamiento.Nombre = f;
                        fraccionamiento.CodigoPostal = cp;
                        fraccionamiento.Municipio = municipio;
                        if(todosLosFraccionamientos)
                            this.SEPOMEX.fraccionamientosSEPOMEXalta.push(fraccionamiento); 
                        else
                            this.SEPOMEX.fraccionamientosSEPOMEX.push(fraccionamiento);
                        this.SEPOMEX.contadorFraccionamientos ++;
                    });
                    resolve();
                }
                else {
                    resolve([]);
                }
            });
        },
         /**
         * funcion encargado de asignar los valores del evento change del catalogo municipios SEPOMEX.
         * @param {Object} evento [evento emitido por catalogo]
         */
        cambioDeMunicipioSEPOMEX: function(evento) {
            this.SEPOMEX.filtros.municipio = evento.target.options[evento.target.selectedIndex].text;
            this.SEPOMEX.filtros.tipoMunicipioId = parseInt(evento.target.value);
            //console.log(this.SEPOMEX.filtros.municipio);
        },
        eventoFiltrarFraccionamientos: function() {
             /* this.cargandoFraccionamientos = true; */
             this.listaDeFraccionamientos = [];
             this.cargarFraccionamientosRegistradosBD();
        },
        eventoEliminarFraccionamiento: function(evento) {
            //console.log('entro::eventoEliminarFraccionamiento');
            const FRACCIONAMIENTO = this.obtenerFraccionamientoSeleccionado(evento);
            let peticion = {};
            peticion.esPrueba = false;
            peticion.Fraccionamiento = FRACCIONAMIENTO;
            const NOMBRE = FRACCIONAMIENTO.Nombre;
            this.informarConfirmacionDeEliminar(NOMBRE, peticion);
        },
        eliminarFraccionamientoBD: function(peticionAPI) {
            const SERVIDOR = api.conexion;
            const METODO_API_ELIMINAR = api.SINOJ.sistema.administracion.fraccionamientos.EliminarFraccionamiento;
            let urlApi = SERVIDOR + METODO_API_ELIMINAR;
            let peticionArchivos = false;
            let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
            comun.SeEstaCargandoInformacion(true);
            axios.post(urlApi, peticionAPI, headerPeticion)
                    .then(respuesta => {            
                        if (respuesta.data.SiHayError) {
                            let mensajeError = respuesta.data.Error.Mensaje;
                            console.log(mensajeError);
                            comun.mensajeDeAlerta(mensajeError, null, null);
                        } 
                        else {
                            //console.log("ejecuto bien :: " + respuesta.data);
                            /* this.cargandoFraccionamientos = true;
                            this.cargarFraccionamientosRegistradosBD(); */
                            comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
                            this.listaDeFraccionamientosBD = this.listaDeFraccionamientosBD.filter(fBD => fBD.FraccionamientoId != respuesta.data.Fraccionamiento.FraccionamientoId);
                            this.listaDeFraccionamientos = this.listaDeFraccionamientos.filter(fT => fT.Folio != respuesta.data.Fraccionamiento.FraccionamientoId);
                            this.contRenderTablaFraccionamientos ++;
                        }
                        comun.SeEstaCargandoInformacion(false);
                    })
                    .catch(excepcion => {
                        comun.SeEstaCargandoInformacion(false);
                        console.log(excepcion);
                        comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
                    }
            ); 
        },
        eventoEditarFraccionamiento: function(evento) {
            this.fraccionamientoSeleccionado = this.obtenerFraccionamientoSeleccionado(evento);
            this.asignarDatosEdicionEnFormulario(this.fraccionamientoSeleccionado);
            this.modoEdicion = true;
            $('#formularo-fraccionamiento').modal('show');
        },
        obtenerFraccionamientoSeleccionado: function(evento) {
            let fraccionamiento = null;
            const fraccionamientoSeleccionado = evento.target.getAttribute('id');
            const idFraccionamiento = parseInt(this.obtenerIdFraccionamientoTabla(fraccionamientoSeleccionado));
            this.listaDeFraccionamientosBD.filter(fBD => fBD.FraccionamientoId == idFraccionamiento).forEach(f => {
                fraccionamiento = f;
            });
            return fraccionamiento;
        },
        obtenerIdFraccionamientoTabla: function(fraccionamientoSeleccionado) {
            const fraccionamiento = fraccionamientoSeleccionado.split('-');
            const posicionDeId = (fraccionamiento.length - 1);
            const idFraccionamiento = fraccionamiento[posicionDeId];
            return idFraccionamiento;
        },
        asignarDatosEdicionEnFormulario: function(fraccionamiento) {
            this.fraccionamientoManualmente = fraccionamiento.Nombre;
            this.codigoPostalFraccionamiento = fraccionamiento.CodigoPostal;
            this.tipoMunicipioIdAlta = fraccionamiento.Municipio.MunicipioId;
            this.contadorRenderCatalogos ++;
        },
        validacionFormularioAlta: function(conCampos, conMunicipio) {
            //console.log('entroAque::validacion::');
            let campos = [{input: this.fraccionamientoManualmente, nombreInput: 'Nombre del fraccionamiento'}, 
                          {input: this.codigoPostalFraccionamiento, nombreInput: 'Codigo Postal'}];
            let formularioValido = false;
            let errores = [];
            if(conMunicipio) {
                if(!this.municipioValido()) {
                    this.mostrarErroresFormularioAlta = true;
                    this.mostrarAvisoErrores = true;
                    formularioValido = false;
                    this.mensajeErrorFormularioAlta = `Se detectaron campos incorrectos, por favor revise el municipio al que corresponde el fraccionamiento`;
                    return formularioValido;
                }
            }

            if(conCampos) {
                for(let i=0; i<campos.length; i++) {
                    if(this.cadenaEsVaciaONula(campos[i].input)) {
                        //console.log('entro::if::concampso');
                        this.mostrarErroresFormularioAlta = true;
                        this.mostrarAvisoErrores = true;
                        formularioValido = false;
                        errores.push(`Se detectaron campos incorrectos, por favor revise la información del campo ${campos[i].nombreInput}.`);
                        break;
                    }
                    else {
                        //console.log('entro::else::concampso');
                        /* this.mostrarErroresFormularioAlta = false; */
                        this.mostrarAvisoErrores = this.tipoMunicipioIdAlta ? false: true;
                        formularioValido = true;
                    }
                }
            }
            if(!this.municipioAltaEsCorrecto) {
                this.mensajeErrorFormularioAlta = `Se detectaron campos incorrectos, por favor revise el municipio al que corresponde el fraccionamiento`;
            }
            else {
                this.mensajeErrorFormularioAlta = errores[0];
            }
            return formularioValido;
        },
        municipioValido: function() {
            let municipioValido = true;
            let municipio = this.tipoMunicipioIdAlta;
            if(municipio == undefined || municipio == null || municipio == -1 ) {
                municipioValido = false;
                this.mostrarAvisoErrores = true;
            }
            this.municipioAltaEsCorrecto = municipioValido;
            return municipioValido;
        },
        cadenaEsVaciaONula: function(cadena) {
            let esVaciaONula = false;
            if(cadena == null || cadena == '' || cadena == undefined) {
                esVaciaONula = true;
            }
            return esVaciaONula;
        },
        campoRequeridoEsValido: function(campo) { 
            let esValido = false
            if(typeof campo === 'string' || campo instanceof String) {
                // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
                if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                    esValido = true;
                }
            }
            else if (typeof campo === 'number' || campo instanceof Number) {
                // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
                if (campo != null && campo != undefined && campo > 0) {
                    esValido = true;
                }
            }
            else {
                if (campo != null && campo != undefined) {
                    esValido = true;
                }
            }
            return esValido;
        },
        construirErrorFormularioCampos: function() {
            let errores = [];
            if(!this.municipioValido()) {
                errores.push(`Se detectaron campos incorrectos, por favor revise el municipio al que corresponde el fraccionamiento`);
            }
            if(this.cadenaEsVaciaONula(this.fraccionamientoManualmente)) {
                errores.push(`Se detectaron campos incorrectos, por favor revise la Información del campo Nombre del fraccionamiento.`);
            }
            if(this.cadenaEsVaciaONula(this.codigoPostalFraccionamiento)) {
                errores.push(`Se detectaron campos incorrectos, porfavor revise la Información del campo Código Postal.`);
            }

            if(errores.length > 0) {
                this.mostrarAvisoErrores = true;
                this.mensajeErrorFormularioAlta = errores[0];
            }
            else {
                this.mostrarAvisoErrores = this.tipoMunicipioIdAlta ? false: true;
            }
            return true;
        },
        limpiarFormularioAlta: function() {
            this.fraccionamientoManualmente = null;
            this.codigoPostalFraccionamiento = null;
            this.mostrarAvisoErrores = false;
            this.mostrarErroresFormularioAlta = false;
            this.mensajeErrorFormularioAlta = 'Se detectaron campos incorrectos.';
            this.contadorRenderCatalogos ++;
            this.tipoMunicipioIdAlta = -1;
        },
        eventoGuardarFraccionamiento: function() {
            /* if(!this.modoEdicion) {
                if(this.validacionFormularioAlta(true,true)) {
                    this.guardarFraccionamientoBD();
                }
            }
            else {
                this.editarFraccionamientoBD();
            } */
            if(this.validacionFormularioAlta(true,true)) {
                if(!this.modoEdicion)
                    this.guardarFraccionamientoBD();
                else
                    this.editarFraccionamientoBD();
            }
        },
        editarFraccionamientoBD: function() {
            const SERVIDOR = api.conexion;
            const METODO_API_AGREGAR = api.SINOJ.sistema.administracion.fraccionamientos.EditarFraccionamiento;
            let urlApi = SERVIDOR + METODO_API_AGREGAR;
            let peticionAPI = {};
            peticionAPI.Fraccionamiento = {
                FraccionamientoId: this.fraccionamientoSeleccionado.FraccionamientoId,
                Nombre: this.fraccionamientoManualmente,
                CodigoPostal: this.codigoPostalFraccionamiento,
                Activo: true,
                Municipio: null,
                Domicilios: null
            }; 
            peticionAPI.MunicipioId = this.tipoMunicipioIdAlta;
            peticionAPI.esPrueba = false;
            let peticionArchivos = false;
            let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
            $('#btn-cerrar-formulario-alta-fraccionamiento').trigger('click');
            comun.SeEstaCargandoInformacion(true);
            axios.post(urlApi, peticionAPI, headerPeticion)
                    .then(async (respuesta) => {            
                        if (respuesta.data.SiHayError) {
                            let mensajeError = respuesta.data.Error.Mensaje;
                            console.log(mensajeError);
                            comun.mensajeDeAlerta(mensajeError, null, null);
                        } 
                        else {
                            //console.log("ejecuto bien :: " + respuesta.data);
                            this.limpiarFormularioAlta();
                            comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
                        
                            /* this.cargandoFraccionamientos = true;
                                this.listaDeFraccionamientos = [];
                            this.cargarFraccionamientosRegistradosBD(); */
                            this.cargandoFraccionamientos = true;
                            await Promise.resolve(this.actaulizarInformacionDeFraccionamientos({ fraccionamientosDB: [ respuesta.data.Fraccionamiento ] }));
                            this.cargandoFraccionamientos = false;
                        }
                        comun.SeEstaCargandoInformacion(false);
                    })
                    .catch(excepcion => {
                        comun.SeEstaCargandoInformacion(false);
                        console.log(excepcion);
                        comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
                    }
            ); 
        },
        guardarFraccionamientoBD: function() {
            const SERVIDOR = api.conexion;
            const METODO_API_AGREGAR = api.SINOJ.sistema.administracion.fraccionamientos.GuardarNuevoFraccionamiento;
            let urlApi = SERVIDOR + METODO_API_AGREGAR;
            let peticionAPI = {};
            peticionAPI.Fraccionamiento = {
                FraccionamientoId: -1,
                Nombre: this.fraccionamientoManualmente,
                CodigoPostal: this.codigoPostalFraccionamiento,
                Activo: true,
                Municipio: null,
                Domicilios: null
            };
            peticionAPI.MunicipioId = this.tipoMunicipioIdAlta;
            peticionAPI.esPrueba = false;
            let peticionArchivos = false;
            let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
            $('#btn-cerrar-formulario-alta-fraccionamiento').trigger('click');
            comun.SeEstaCargandoInformacion(true);
            axios.post(urlApi, peticionAPI, headerPeticion)
                    .then(async (respuesta) => {            
                        if (respuesta.data.SiHayError) {
                            let mensajeError = respuesta.data.Error.Mensaje;
                            console.log(mensajeError);
                            comun.mensajeDeAlerta(mensajeError, null, null);
                        } 
                        else {
                            //console.log("ejecuto bien :: " + respuesta.data);
                            this.limpiarFormularioAlta();
                            comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
                            /* antes de optimizar 18/10/2021
                                this.cargandoFraccionamientos = true;
                                this.listaDeFraccionamientos = [];
                                this.cargarFraccionamientosRegistradosBD(); */
                            this.cargandoFraccionamientos = true;
                            await Promise.resolve(this.actaulizarInformacionDeFraccionamientos({ fraccionamientosDB: [ respuesta.data.Fraccionamiento ], nuevoElemento: true }));
                            this.cargandoFraccionamientos = false;
                        }
                        comun.SeEstaCargandoInformacion(false);
                    })
                    .catch(excepcion => {
                        comun.SeEstaCargandoInformacion(false);
                        console.log(excepcion);
                        comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
                    }
            ); 
        },
        cargarFraccionamientosRegistradosBD: function() {
            this.tablaFraccionamientos.listaParaAsignar = [];
            const SERVIDOR = api.conexion;
            const METODO_API_AGREGAR = api.SINOJ.sistema.administracion.fraccionamientos.ObtenerFraccionamientosRegistrados;
            let urlApi = SERVIDOR + METODO_API_AGREGAR;
            let peticionAPI = {
                FraccionamientoId: null,
                MunicipioId: (this.tipoMunicipioId < 0) ? null : this.tipoMunicipioId,
                CodigoPostal: this.codigoPostal,
                NotificadorId: (this.catalogoNotificadores.valorDefinido < 0) ? null : this.catalogoNotificadores.valorDefinido,
                Nombre: this.nombreFraccionamientoF,
                ConInactivos: false
            };
            peticionAPI.esPrueba = false;
            let peticionArchivos = false;
            let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
            this.cargandoFraccionamientos = true;
            comun.SeEstaCargandoInformacion(true);
            axios.post(urlApi, peticionAPI, headerPeticion)
                    .then(respuesta => {            
                        if (respuesta.data.SiHayError) {
                            let mensajeError = respuesta.data.Error.Mensaje;
                            console.log(mensajeError);
                            comun.mensajeDeAlerta(mensajeError, null, null);
                        } 
                        else {
                            //console.log("ejecuto bien getfracc:: ",respuesta.data);
                             this.listaDeFraccionamientosBD = respuesta.data.Fraccionamientos;
                             this.listaDeFraccionamientos = this.fraccionamientoBDaObj(this.listaDeFraccionamientosBD);

                             if(this.campoRequeridoEsValido(respuesta.data.Fraccionamientos) && respuesta.data.Fraccionamientos.length > 0) {
                                // persiste la seleccion anterior a la busqueda
                                this.persistirSeleccionDeFraccionamientos();

                                //se agrega eventos para el filtro de busqueda en memoria de la tabla
                                $("#inputs-filtro-memoria input").on("change paste keyup", (e) => {
                                    if(this.listaDeFraccionamientosBD.length > 0) {
                                        this.filtrarFraccionamientosTabla(e);
                                    }
                                });
                             }
                        }
                        comun.SeEstaCargandoInformacion(false);
                        this.cargandoFraccionamientos = false;
                    })
                    .catch(excepcion => {
                        comun.SeEstaCargandoInformacion(false);
                        console.log(excepcion);
                        comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
                    }
            ); 
        },
        filtrarFraccionamientosTabla: function(e) {
            // filtra por columnas y nivel de prioridad
            this.listaDeFraccionamientos = this.fraccionamientoBDaObj(this.listaDeFraccionamientosBD)
            .filter(c => {
                return Object.values(c).some(valorColumna => this.predicateFiltradoPorSimilitud(valorColumna, this.tablaFraccionamientos.buscarPor));
            });
            this.persistirSeleccionDeFraccionamientos();
        },
        predicateFiltradoPorSimilitud: function(elementoAEvaluar,compararCon) { 
            if(this.campoRequeridoEsValido(compararCon)) {
            if(elementoAEvaluar.toString().toUpperCase().startsWith(compararCon.toString().toUpperCase()))
                return true;
            else
                return false;
            }
            else
                return true;
        },
        persistirSeleccionDeFraccionamientos: function() { 
            this.tablaFraccionamientos.listaParaAsignar = [];
            /* this.$nextTick(() => { 
                this.tablaFraccionamientos.listaParaAsignar.filter(f => f.enviar).forEach(fraccSeleccionado => { 
                    let fraccEstaEnSelccionados = this.listaDeFraccionamientosBD.some(f => f.FraccionamientoId == fraccSeleccionado.folio);
                    if(fraccEstaEnSelccionados)
                        this.$refs[this.tablaFraccionamientos.REF].seleccionDeCedulaComponentePadre(fraccSeleccionado.idCheck);
                });
                //let tabla = this.$refs[this.tablaFraccionamientos.REF];
                //this.tablaFraccionamientos.listaParaAsignar = this.$refs[this.tablaFraccionamientos.REF].cedulasAEnviar.filter(f => f.enviar);
            });
            //console.log(this.cedulasEnvioAJuzgado); */
        },
        fraccionamientoBDaObj: function(fraccionamientos) {
            /*let fraccionamientos = [];
            // {Folio: 1,Nombre: 'Fraccionamiento 1',CodigoPostal:'001',Municipio:'Municipio 1',Estatus: 'Activo'}
            this.listaDeFraccionamientosBD.forEach(fBD => {
                let fraccionamiento = {};
                fraccionamiento.Folio = fBD.FraccionamientoId;
                fraccionamiento.Nombre = fBD.Nombre;
                fraccionamiento.CodigoPostal = fBD.CodigoPostal;
                fraccionamiento.Municipio = fBD.Municipio.Nombre;
                fraccionamiento.Estatus = (fBD.Activo) ? 'Activo' : 'Inactivo';
                fraccionamientos.push(fraccionamiento);
            });
            //this.listaDeFraccionamientos = fraccionamientos;
            this.cargandoFraccionamientos = false;
            //console.log('notififcadorBDaNotificadorObj::',this.listaDeFraccionamientos);
            return fraccionamientos;*/
            console.log('fraccionamientos::',fraccionamientos);
            let fraccionamientosTabla = [];
            if(this.campoRequeridoEsValido(fraccionamientos)) {
                fraccionamientosTabla = fraccionamientos.map(fBD => {
                    let fraccionamiento = {};
                    fraccionamiento.Folio = fBD.FraccionamientoId;
                    fraccionamiento.Nombre = fBD.Nombre;
                    fraccionamiento.CodigoPostal = fBD.CodigoPostal;
                    fraccionamiento.Municipio = fBD.Municipio.Nombre;
                    fraccionamiento.Estatus = (fBD.Activo) ? 'Activo' : 'Inactivo';
                    fraccionamiento.asignacion = this.obtenerNombreNotificador(fBD.NotificadoresAsignados);
                    return fraccionamiento;
                })
            }
            /* this.cargandoFraccionamientos = false; */
            return fraccionamientosTabla;
        },
        obtenerNombreNotificador: function(asignaciones) { 
            let nombreCompleto = 'Sin notificador'
            if(asignaciones != null && asignaciones.length > 0) {
                let notificador = asignaciones[0].Notificador;
                if(notificador != null && notificador != undefined) {
                    const { Usuario } = notificador;
                    if(Usuario != null && Usuario != undefined) {
                        const DATOS_DE_NOMBRE = [Usuario.Nombre, Usuario.ApellidoPaterno, Usuario.ApellidoMaterno];
                        nombreCompleto = DATOS_DE_NOMBRE.join(' ');
                    }
                }
            }
            return nombreCompleto;
        },
        cambioDeMunicipio: function(evento) {
            this.tipoMunicipioId = parseInt(evento.target.value);
        },
        cambioDeMunicipioAlta: function(evento) {
            this.tipoMunicipioIdAlta = parseInt(evento.target.value);
            this.municipioAltaEsCorrecto = this.municipioValido();
        },
        eliminarFraccionamiento: function(evento) {
            const fraccionamientoSeleccionado = evento.target.getAttribute('id');
            const idFraccionamiento = parseInt(this.obtenerIdDeFraccionamiento(fraccionamientoSeleccionado));
            const indexDeFraccionamiento = this.listaDeFraccionamientos.findIndex(fr => fr.Folio == idFraccionamiento);
            if(indexDeFraccionamiento > -1) {
                this.listaDeFraccionamientos.splice(indexDeFraccionamiento,1);
            }
        },
        mostrarFormulario: function() {
            this.modoEdicion = false;
           /*  this.conCatalogos = true;
            this.manualmente = false; */
            $('#formularo-fraccionamiento').modal('show');
        },
        cambiarEstatus: function(evento) {
            const fraccionamientoSeleccionado = evento.target.getAttribute('id');
            this.modoEdicion = true;
            this.conCatalogos = false;
            this.manualmente = true;
            $('#formularo-fraccionamiento').modal('show');
        },
        obtenerIdDeFraccionamiento: function(fraccionamientoSeleccionado) {
            const fraccionamiento = fraccionamientoSeleccionado.split('-');
            const posicionDeId = (fraccionamiento.length - 1);
            const idFraccionamiento = fraccionamiento[posicionDeId];
            return idFraccionamiento;
        },
         /**
         * Metodo encargado de mostrar alerta bootbox para confirmacion. 
         * @param {bool} fraccionamiento [fraccionamiento que se eliminara]
         * @see {@link eliminarFraccionamientoBD}
         */
        informarConfirmacionDeEliminar: function (fraccionamiento, peticion) {
            bootbox.confirm({
                title: "Mensaje del sistema",
                message: `Estas seguro que deseas eliminar el fraccionamiento  '${fraccionamiento}'<br>¿Desea continuar?`,
                buttons: {
                    cancel: {
                        label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                    },
                    confirm: {
                        label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Aceptar'
                    }
                },
                callback: (respuesta) => {
                    if (respuesta) {
                        this.eliminarFraccionamientoBD(peticion);
                    }
                }
            });
        },
        cargaCatalogoDeMunicipios: async function() {  
           let peticionAPI = { EntidadFederativaId: enumeraciones.pj.entidadesFederativas.Aguascalientes };
           let peticionMunicipios = await axios.post(api.conexion + api.PJ.catalogos.C010Municipios, peticionAPI);
           let respuestaPeticion = await peticionMunicipios.data;
           this.municipiosAgsCatalogo = (respuestaPeticion.SiHayError) ? [] : respuestaPeticion.Municipios;
        },
        puedeAdministrarTodo: function(modulos) {
            if(modulos != null && modulos != undefined && modulos.length > 0) {
                const MODULO_ADMIN = 3; // modulo administracion en caso de cambiar remplazar por ID en bd 
                this.permisos.revisoPermisos = true;
                const MODULO = modulos.find(m => m.ModuloId == MODULO_ADMIN);
                if(MODULO != null) {
                    //console.log('perm_modulo::',MODULO);
                    const FUNCIONES_DE_MODULO = MODULO.Funciones;
                    if(FUNCIONES_DE_MODULO != null && FUNCIONES_DE_MODULO.length > 0) {
                        const FUNCION_ADMIN_TOTAL = 19; // funcion AdministracionTotalFraccionamientos en caso de cambiar remplazar por ID en bd
                        this.permisos.administracionTotal = FUNCIONES_DE_MODULO.some(f => f.FuncionId == FUNCION_ADMIN_TOTAL);
                    }
                    else
                        this.permisos.administracionTotal = false;
                }
                else
                    this.permisos.administracionTotal = false;         
            }
            else
               this.permisos.administracionTotal = false;
        },
    },
    created() {
        this.cargarFraccionamientosRegistradosBD();
        if(!this.permisos.revisoPermisos)
            this.puedeAdministrarTodo(this.$store.state.Login_PermisosDelSistema);
    },
    computed: {
        obtenerNumeroDeFraccionamientos() {
            return this.SEPOMEX.numFraccGuardar;
        },
        administraTodo() {
            return this.permisos.administracionTotal;
        }
    },
    watch: {
        '$store.state.Login_PermisosDelSistema': function() {
            if(!this.permisos.revisoPermisos)
                this.puedeAdministrarTodo(this.$store.state.Login_PermisosDelSistema);
        },
        'asignaciones.catalogoNotificadores.valorDefinido': function() {
            if(this.campoRequeridoEsValido(this.asignaciones.catalogoNotificadores.valorDefinido))
                this.asignaciones.mostrarError = false;
        }
        /* 
        'tablaFraccionamientos.listaParaAsignar': function() { 
            let todosLosElementosSeleccionados = (this.tablaFraccionamientos.listaParaAsignar.filter(f => f.enviar).length == this.listaDeFraccionamientos.length);
            this.$refs[this.tablaFraccionamientos.REF].mostrarSeleccionTodoComponentePadre(todosLosElementosSeleccionados);
        } */
    }
}
</script>
<style scoped>
.cursor-seleccion {
    cursor: pointer;
}
#pasos-asignacion-fraccionamientos h6 {
    font-size: 1em !important;
    margin-bottom: 3px;
}

#formulario-asignacion .modal-lg {
    max-width: 70% !important;
}

#formulario-asignacion .modal-header {
    background-color: rgb(36, 34, 34);;
    border: none;
}

#formulario-asignacion .modal-footer {
    border-top: 2px solid rgb(37, 37, 37);
}

#f-busqueda {
    width: 20em;
}

#contendor-fraccionamientos {
    display: flex;
    justify-content: center;
}

@media only screen and (max-width: 900px) {
    #contenedor-filtro-busqueda {
         flex-direction: column !important;
    }

    #contenedor-filtro-busqueda div {
         width: 100% !important;

    }
}

#contenedor-campos-informativos-guardar {
    align-items: center;
    justify-content: center;
    margin-top: 2em; 
    display:flex; 
    justify-content: space-between;
    margin-top: 2em;
}

.contenedor-color-negro {
    padding: 1.5em;
    background-color: #2c2d31;
    box-shadow: 0px 6px 20px 8px #161616;
}

.btn-primary {
    color: white;
    background-color: rgb(36, 34, 34);
    border-color: white;
}

#encabezado-contenedor-contenido {
  background-color: rgb(44, 43, 43);
  padding: 10px;
}

.btn-primary:hover {
    color: white;
    background-color: black;
    border-color: white;
}

.modal-header {
    background-color: rgb(36, 34, 34);;
    border: none;
}

#titulo-tabla {
    background-color: #1b1919;
    margin-top:0.9em;
    padding: 10px;
    padding-left: 33px;
    margin-bottom: 0px;
    display: flex;
    justify-content: space-between;
}

.contenedor-alineacion-horizontal {
    display: flex;
    justify-content: flex-end;
    align-items: center;
}

.modal-dialog {
  max-width: 40% !important;
}

.btn-primary:focus {
    color: white;
    background-color: black;
    border-color: white;
    box-shadow: none;;
}

#contenedor-filtro-busqueda {
    display: flex;
}

.btn-secondary:not(:disabled):not(.disabled).active, .btn-secondary:not(:disabled):not(.disabled):active, .show>.btn-secondary.dropdown-toggle {
    color: white;
    background-color: #57585B;
    border-color: white;
}

.btn-secondary {
    color: rgb(106, 108, 112);
    background-color: #323335;
    border-color: rgb(106, 108, 112);
    font-size: 0.95rem;
}
.btn-secondary:hover {
    color: white;
    background-color: #323335;
    border-color: white;
}
#contenedor-error-formulario {
    padding: 1em;
    background-color: #26272b;
    border: 1px solid #5c5959;
    border-radius: 8px;
    margin-bottom: 1em;;
}

.contenedor-sin-fraccionamientos {
    background-color: rgb(36, 34, 34);
    height: 40px;
    height: 21rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

#menuConsultaExterna h6:hover, #misEmpresas h6:focus {
    text-decoration-line: underline;
    font-weight: bold;
    cursor: pointer;
}

.contenedor-cargando {
    background-color: rgb(36, 34, 34);
    height: 40px;
    height: 21rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

#filtros-memoria-fracc-vcdd .btn-sm {
  cursor: pointer;
  background-color: rgb(27, 25, 25);
  padding: 5px 15px 5px 15px;
} 

#filtros-memoria-fracc-vcdd .btn-sm:hover, #filtros-fracc-cedulas-vcdd .btn-sm:focus {
  background-color: black;
}

#filtros-memoria-fracc-vcdd .form-control::-webkit-input-placeholder { color: rgb(201, 192, 192); }  /* WebKit, Blink, Edge */
#filtros-memoria-fracc-vcdd .form-control:-moz-placeholder { color:  rgb(201, 192, 192); }  /* Mozilla Firefox 4 to 18 */
#filtros-memoria-fracc-vcdd .form-control::-moz-placeholder { color:  rgb(201, 192, 192); }  /* Mozilla Firefox 19+ */
#filtros-memoria-fracc-vcdd .form-control:-ms-input-placeholder { color:  rgb(201, 192, 192); }  /* Internet Explorer 10-11 */
#filtros-memoria-fracc-vcdd .form-control::-ms-input-placeholder { color:  rgb(201, 192, 192); }  /* Microsoft Edge */



</style>


// WEBPACK FOOTER //
// src/components/SINOJ/Administracion/Fraccionamientos/CFraccionamientos.vue